/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GrundbuchmeldungSearchRequest } from '../model/grundbuchmeldungSearchRequest';
// @ts-ignore
import { GrundbuchmeldungSearchRequestMeta } from '../model/grundbuchmeldungSearchRequestMeta';
// @ts-ignore
import { GrundbuchmeldungSearchResponseMeta } from '../model/grundbuchmeldungSearchResponseMeta';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbgrundbuchmeldungService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param sprache 
     * @param grundbuchmeldungSearchRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sprache === null || sprache === undefined) {
            throw new Error('Required parameter sprache was null or undefined when calling downloadGrundbuchmeldungZip.');
        }
        if (grundbuchmeldungSearchRequest === null || grundbuchmeldungSearchRequest === undefined) {
            throw new Error('Required parameter grundbuchmeldungSearchRequest was null or undefined when calling downloadGrundbuchmeldungZip.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/zip'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/gb/grundbuchmeldung/grundbuchmeldungZip/${this.configuration.encodeParam({name: "sprache", value: sprache, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<Array<string>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: grundbuchmeldungSearchRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gbaId 
     * @param jahr 
     * @param tbnr 
     * @param index 
     * @param gdeId 
     * @param gsNr 
     * @param gsnrZusatz 
     * @param gsNr3 
     * @param gsNr4 
     * @param egrid 
     * @param egDatumVon 
     * @param egDatumBis 
     * @param absDatumVon 
     * @param absDatumBis 
     * @param status 
     * @param name 
     * @param vorname 
     * @param versNr 
     * @param egid 
     * @param bearbeitet 
     * @param nichtBearbeitet 
     * @param registraturText 
     * @param regionId 
     * @param timestamp 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timestamp?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GrundbuchmeldungSearchResponseMeta>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timestamp?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GrundbuchmeldungSearchResponseMeta>>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timestamp?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GrundbuchmeldungSearchResponseMeta>>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timestamp?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (gbaId !== undefined && gbaId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gbaId, 'gbaId');
        }
        if (jahr !== undefined && jahr !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>jahr, 'jahr');
        }
        if (tbnr !== undefined && tbnr !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tbnr, 'tbnr');
        }
        if (index !== undefined && index !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>index, 'index');
        }
        if (gdeId !== undefined && gdeId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gdeId, 'gdeId');
        }
        if (gsNr !== undefined && gsNr !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gsNr, 'gsNr');
        }
        if (gsnrZusatz !== undefined && gsnrZusatz !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gsnrZusatz, 'gsnrZusatz');
        }
        if (gsNr3 !== undefined && gsNr3 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gsNr3, 'gsNr3');
        }
        if (gsNr4 !== undefined && gsNr4 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gsNr4, 'gsNr4');
        }
        if (egrid !== undefined && egrid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>egrid, 'egrid');
        }
        if (egDatumVon !== undefined && egDatumVon !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>egDatumVon, 'egDatumVon');
        }
        if (egDatumBis !== undefined && egDatumBis !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>egDatumBis, 'egDatumBis');
        }
        if (absDatumVon !== undefined && absDatumVon !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>absDatumVon, 'absDatumVon');
        }
        if (absDatumBis !== undefined && absDatumBis !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>absDatumBis, 'absDatumBis');
        }
        if (status !== undefined && status !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>status, 'status');
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (vorname !== undefined && vorname !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vorname, 'vorname');
        }
        if (versNr !== undefined && versNr !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>versNr, 'versNr');
        }
        if (egid !== undefined && egid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>egid, 'egid');
        }
        if (bearbeitet !== undefined && bearbeitet !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bearbeitet, 'bearbeitet');
        }
        if (nichtBearbeitet !== undefined && nichtBearbeitet !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nichtBearbeitet, 'nichtBearbeitet');
        }
        if (registraturText !== undefined && registraturText !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>registraturText, 'registraturText');
        }
        if (regionId !== undefined && regionId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>regionId, 'regionId');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/gb/grundbuchmeldung/search`;
        return this.httpClient.request<GrundbuchmeldungSearchResponseMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchTemplateGrundbuchmeldung(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GrundbuchmeldungSearchRequestMeta>;
    public searchTemplateGrundbuchmeldung(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GrundbuchmeldungSearchRequestMeta>>;
    public searchTemplateGrundbuchmeldung(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GrundbuchmeldungSearchRequestMeta>>;
    public searchTemplateGrundbuchmeldung(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/gb/grundbuchmeldung/searchTemplate`;
        return this.httpClient.request<GrundbuchmeldungSearchRequestMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
